<template>
  <div class="side-frame-warning">
    <span style="font-size: 14px; color: #606266">{{
      $l('INDEX.order_tab_group_order_package_size') || '包装尺寸'
    }}</span>
    <el-divider direction="vertical"></el-divider>
    <b-button-group size="sm">
      <b-button
        class="mr-2"
        variant="outline-success"
        @click="$emit('openAddDialog', { type: 'add' })"
        :disabled="disabled"
      >
        <i class="el-icon-plus" />
        {{ $l('INDEX.btn_add') || '添加' }}
      </b-button>
      <b-button
        :disabled="disabled"
        variant="outline-danger"
        @click="$emit('batchDel')"
      >
        <i class="el-icon-delete"></i>
        {{ $l('INDEX.btn_delete') || '删除' }}
      </b-button>
    </b-button-group>
  </div>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
